import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'
import {NavBlock as InnerBlock} from './NavBlock'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const GlobalAdmin = lazy(() =>
  import('./admin').then(m => ({default: m.GlobalAdmin})),
)

export const navBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  GlobalAdmin,
  InnerBlock,
  dividers: false, // Nav component supplies its own
})
